module.exports = __webpack_public_path__ + "static/media/hingeDividing.ebda21a8.png";